export const tokenColors = {
  grey: {
    34: '#222222',
    41: '#292929',
    68: '#444444',
    86: '#565656',
    102: '#666666',
    148: '#949494',
    153: '#999999',
    187: '#BBBBBB',
    190: '#BEBEBE',
    204: '#CCCCCC',
    217: '#D9D9D9',
    227: '#E3E3E3',
    233: '#E9E9E9',
    240: '#F0F0F0',
    245: '#F5F5F5',
  },
  primary: {
    main: '#EE0000',
    dark: '#D10000',
    darker: '#B60000',
    white: '#FFFFFF',
    black: '#000000',
  },
  sunshine: {
    lighter: '#F8F9C2',
    light: '#FFE167',
    main: '#FFC900',
    dark: '#A88400',
    darker: '#634E00',
  },
  peach: {
    lighter: '#FFDEB8',
    light: '#FFBA54',
    main: '#FF8F00',
    dark: '#D14800',
    darker: '#782A00',
  },
  berry: {
    lighter: '#FFDADB',
    light: '#F3B6B6',
    main: '#ED005F',
    dark: '#A3003F',
    darker: '#710035',
  },
  fuchsia: {
    lighter: '#FEDDEE',
    light: '#FD83C7',
    main: '#E0009D',
    dark: '#AB0077',
    darker: '#820059',
  },
  aubergine: {
    lighter: '#E2D6EB',
    light: '#CB9DE0',
    main: '#9B348E',
    dark: '#741B78',
    darker: '#551158',
  },
  night: {
    lighter: '#BCCBEA',
    light: '#7182B9',
    main: '#4648B8',
    dark: '#33348B',
    darker: '#1A1A50',
  },
  aqua: {
    lighter: '#F1F5FF',
    light: '#88ACFF',
    main: '#2C57D2',
    dark: '#0047FF',
    darker: '#0035C6',
  },
  ocean: {
    lighter: '#A7E9FF',
    light: '#6ADCFF',
    main: '#00ACD3',
    dark: '#387F99',
    darker: '#245669',
  },
  mint: {
    lighter: '#C1FFFF',
    light: '#9EF7EF',
    main: '#33DACB',
    dark: '#00847F',
    darker: '#005B57',
  },
  garden: {
    lighter: '#EFF7F5',
    light: '#74D6B5',
    main: '#009864',
    dark: '#266446',
    darker: '#1B4B34',
  },
  forest: {
    lighter: '#E4EDDB',
    light: '#ADC992',
    main: '#8CD000',
    dark: '#5A8700',
    darker: '#2B5500',
  },
};
